import React, { useState } from 'react';
import { Table, Tbody, Td,Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import Pagination from "components/ui/pagination/Pagination";

export default function InventoryItemsCostDataTable({data}) {
    const { t } = useTranslation();

/* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const inventoryItemsCostData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
                <Tr>
                    <Th>{t("pages.reports.reports_tables.name")}</Th>
                    <Th>{t("pages.reports.reports_tables.sku")}</Th>
                    <Th>{t("pages.reports.reports_tables.costing_method")}</Th>
                    <Th>{t("pages.reports.reports_tables.cost")}</Th>
                </Tr>
        </Thead>
        <Tbody>
            {
            inventoryItemsCostData?.map((item, index) => (
                <Tr key={index}>  
                    <Td>{item?.InventoryItemNameEng}</Td>
                    <Td>{item?.SKU}</Td>
                    <Td>{item?.CostingMethod}</Td>
                    <Td> {item?.Cost}  </Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
            currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};
